var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-5",attrs:{"elevation":"2","outlined":""}},[_c('v-card-title',[_vm._v("Member code")]),_c('v-data-table',{staticClass:"row-pointer",attrs:{"headers":_vm.headers,"items":_vm.memberData,"item-key":"code"},on:{"click:row":_vm.filterMember}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }